import React from 'react';
import { Col, Row } from 'antd';

import { Logo, Subtitle, Title } from './styles';

const LOGO_URL = 'https://kinebot-statics.s3.amazonaws.com/kinebot_logo.png';
const HEADER_GUTTER = 40;

interface ResultHeaderProps {
	subtitle: string;
	title: string;
}

export function ResultHeader({ subtitle, title }: Readonly<ResultHeaderProps>): JSX.Element {
	return (
		<Row align="middle" gutter={[HEADER_GUTTER, 0]} wrap={false}>
			<Col>
				<Logo src={LOGO_URL} alt="Kinebot" />
			</Col>
			<Col flex="auto">
				<Subtitle>{subtitle}</Subtitle>
				<Title>{title}</Title>
			</Col>
		</Row>
	);
}
